import BackButton from '../components/BackButton'

const paypalManageUrl = 'https://www.paypal.com/myaccount/autopay/'

function formatDate(iso) {
  if (!iso) {
    return '-'
  }

  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) {
    return '-'
  }

  return date.toLocaleDateString('es-AR', { year: 'numeric', month: 'long', day: 'numeric' })
}

function Membership({ subscription, onCancel, onBack }) {
  return (
    <main className="screen">
      <section className="dashboard-header">
        <BackButton onClick={onBack} />
        <p className="eyebrow">Ajustes</p>
        <h1>Membresia</h1>
      </section>

      <section className="profile-info">
        <div>
          <span>Estado</span>
          <strong>{subscription.active ? 'Activa' : 'Cancelada'}</strong>
        </div>
        <div>
          <span>Metodo de pago</span>
          <strong>{subscription.provider === 'paypal' ? 'PayPal' : subscription.provider ?? '-'}</strong>
        </div>
        <div>
          <span>ID de suscripcion</span>
          <strong>{subscription.subscriptionId ?? '-'}</strong>
        </div>
        <div>
          <span>Activa desde</span>
          <strong>{formatDate(subscription.startedAt)}</strong>
        </div>
      </section>

      <p className="account-hint">
        Cancelar aca da de baja el cobro recurrente en PayPal y detiene tu acceso en la app de inmediato.
      </p>

      <section className="legal-links">
        <a href={paypalManageUrl} target="_blank" rel="noopener noreferrer">
          Gestionar pagos en PayPal
        </a>
      </section>

      <button type="button" className="secondary full-width danger-text" onClick={onCancel}>
        Cancelar suscripcion
      </button>
    </main>
  )
}

export default Membership
